import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, FilterIcon, SearchIcon } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { Product } from '../context/CartContext';
// Product data
const allProducts: Product[] = [{
  id: 1,
  name: 'Lavender Essential Oil',
  price: 'KSh 1,500',
  priceValue: 1500,
  rating: 5,
  reviews: 124,
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop',
  description: 'Pure lavender oil for relaxation and skin care.',
  badge: 'Best Seller',
  category: 'single'
}, {
  id: 2,
  name: 'Tea Tree Essential Oil',
  price: 'KSh 1,200',
  priceValue: 1200,
  rating: 4.5,
  reviews: 98,
  image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop',
  description: 'Powerful antiseptic oil with cleansing properties.',
  category: 'single'
}, {
  id: 3,
  name: 'Eucalyptus Essential Oil',
  price: 'KSh 1,300',
  priceValue: 1300,
  rating: 4.8,
  reviews: 76,
  image: 'https://images.unsplash.com/photo-1600857544200-b2f468e9d10d?q=80&w=600&auto=format&fit=crop',
  description: 'Refreshing oil that promotes clear breathing.',
  badge: 'New',
  category: 'single'
}, {
  id: 4,
  name: 'Lemongrass Essential Oil',
  price: 'KSh 1,100',
  priceValue: 1100,
  rating: 4.7,
  reviews: 65,
  image: 'https://images.unsplash.com/photo-1601055283742-8b27e81b5553?q=80&w=600&auto=format&fit=crop',
  description: 'Citrusy oil that helps reduce stress.',
  category: 'single'
}, {
  id: 5,
  name: 'Peppermint Essential Oil',
  price: 'KSh 1,400',
  priceValue: 1400,
  rating: 4.9,
  reviews: 112,
  image: 'https://images.unsplash.com/photo-1600857462034-6cd98ca80095?q=80&w=600&auto=format&fit=crop',
  description: 'Cooling and refreshing oil for energy and focus.',
  category: 'single'
}, {
  id: 6,
  name: 'Rosemary Essential Oil',
  price: 'KSh 1,250',
  priceValue: 1250,
  rating: 4.6,
  reviews: 89,
  image: 'https://images.unsplash.com/photo-1595981267030-ca121bcf4df9?q=80&w=600&auto=format&fit=crop',
  description: 'Herbaceous oil that promotes mental clarity.',
  category: 'single'
}, {
  id: 7,
  name: 'Relaxation Blend',
  price: 'KSh 1,800',
  priceValue: 1800,
  rating: 4.8,
  reviews: 75,
  image: 'https://images.unsplash.com/photo-1608571423899-ec3cdb9a3a65?q=80&w=600&auto=format&fit=crop',
  description: 'A calming blend of lavender, chamomile, and ylang-ylang.',
  badge: 'Popular',
  category: 'blend'
}, {
  id: 8,
  name: 'Respiratory Blend',
  price: 'KSh 1,700',
  priceValue: 1700,
  rating: 4.7,
  reviews: 62,
  image: 'https://images.unsplash.com/photo-1608571423896-71e99248e144?q=80&w=600&auto=format&fit=crop',
  description: 'A clearing blend of eucalyptus, tea tree, and peppermint.',
  category: 'blend'
}, {
  id: 9,
  name: 'Ultrasonic Diffuser',
  price: 'KSh 3,500',
  priceValue: 3500,
  rating: 4.9,
  reviews: 128,
  image: 'https://images.unsplash.com/photo-1608571423897-d68e04b0d0b9?q=80&w=600&auto=format&fit=crop',
  description: 'Modern ultrasonic diffuser for essential oils with LED lights.',
  category: 'diffuser'
}, {
  id: 10,
  name: 'Ceramic Diffuser',
  price: 'KSh 2,800',
  priceValue: 2800,
  rating: 4.6,
  reviews: 93,
  image: 'https://images.unsplash.com/photo-1602928298849-325939ef8a9a?q=80&w=600&auto=format&fit=crop',
  description: 'Elegant ceramic diffuser with natural bamboo base.',
  category: 'diffuser'
}, {
  id: 11,
  name: 'Essential Oil Gift Set',
  price: 'KSh 4,500',
  priceValue: 4500,
  rating: 4.9,
  reviews: 156,
  image: 'https://images.unsplash.com/photo-1608571423898-d7b5fa08d966?q=80&w=600&auto=format&fit=crop',
  description: 'Collection of 6 popular essential oils in a beautiful gift box.',
  badge: 'Gift',
  category: 'gift'
}, {
  id: 12,
  name: 'Jojoba Carrier Oil',
  price: 'KSh 950',
  priceValue: 950,
  rating: 4.7,
  reviews: 84,
  image: 'https://images.unsplash.com/photo-1595981267006-5a2140753a5c?q=80&w=600&auto=format&fit=crop',
  description: 'Pure jojoba oil for diluting essential oils for topical use.',
  category: 'carrier'
},
// Wellness products
{
  id: 13,
  name: 'Sleep & Relaxation Kit',
  price: 'KSh 3,200',
  priceValue: 3200,
  rating: 4.8,
  reviews: 65,
  image: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?q=80&w=600&auto=format&fit=crop',
  description: 'Complete kit for better sleep and relaxation.',
  category: 'wellness'
}, {
  id: 14,
  name: 'Aromatherapy Inhaler',
  price: 'KSh 800',
  priceValue: 800,
  rating: 4.6,
  reviews: 42,
  image: 'https://images.unsplash.com/photo-1608571423897-d68e04b0d0b9?q=80&w=600&auto=format&fit=crop',
  description: 'Personal aromatherapy inhaler for on-the-go use.',
  category: 'wellness'
}];
// Category information
const categories = {
  single: {
    title: 'Single Essential Oils',
    description: 'Pure essential oils extracted from a single plant source, offering specific therapeutic benefits.',
    image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=1080&auto=format&fit=crop'
  },
  blend: {
    title: 'Essential Oil Blends',
    description: 'Carefully crafted combinations of essential oils designed to work synergistically for specific purposes.',
    image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=1080&auto=format&fit=crop'
  },
  diffuser: {
    title: 'Diffusers',
    description: 'Modern devices that disperse essential oils into the air, allowing you to enjoy their therapeutic benefits.',
    image: 'https://images.unsplash.com/photo-1608571423901-789422f2d6e5?q=80&w=1080&auto=format&fit=crop'
  },
  wellness: {
    title: 'Wellness Products',
    description: 'Specially formulated products designed to enhance your wellbeing and support a healthy lifestyle.',
    image: 'https://images.unsplash.com/photo-1605637465095-0c5327be0c81?q=80&w=1080&auto=format&fit=crop'
  },
  carrier: {
    title: 'Carrier Oils',
    description: 'Base oils used to dilute essential oils for safe topical application while providing their own beneficial properties.',
    image: 'https://images.unsplash.com/photo-1595981267006-5a2140753a5c?q=80&w=1080&auto=format&fit=crop'
  },
  gift: {
    title: 'Gift Sets',
    description: 'Beautifully packaged collections of our premium products, perfect for introducing someone to essential oils.',
    image: 'https://images.unsplash.com/photo-1608571423898-d7b5fa08d966?q=80&w=1080&auto=format&fit=crop'
  }
};
const CategoryPage = () => {
  const {
    category
  } = useParams<{
    category: string;
  }>();
  const [searchQuery, setSearchQuery] = useState('');
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [sortBy, setSortBy] = useState('featured');
  // Make sure we have a valid category
  const validCategory = category && categories[category as keyof typeof categories] ? category : 'single';
  // Get category info
  const categoryInfo = categories[validCategory as keyof typeof categories];
  // Filter products by category
  const filteredProducts = allProducts.filter(product => {
    // Category filter
    if (product.category !== validCategory) {
      return false;
    }
    // Search filter
    if (searchQuery && !product.name.toLowerCase().includes(searchQuery.toLowerCase()) && !product.description.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    // Price filter
    if (product.priceValue < priceRange[0] || product.priceValue > priceRange[1]) {
      return false;
    }
    return true;
  });
  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === 'price-low') {
      return a.priceValue - b.priceValue;
    } else if (sortBy === 'price-high') {
      return b.priceValue - a.priceValue;
    } else if (sortBy === 'rating') {
      return b.rating - a.rating;
    }
    // Default: featured/newest
    return 0;
  });
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-779">
      {/* Hero Section */}
      <div className="relative h-[40vh] overflow-hidden" data-id="element-780">
        <img src={categoryInfo.image} alt={categoryInfo.title} className="w-full h-full object-cover" onError={e => {
        e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=1080&auto=format&fit=crop';
      }} data-id="element-781" />
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-end" data-id="element-782">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-783">
            <Link to="/products" className="mb-6 inline-flex items-center text-white hover:text-green-100 transition-colors" data-id="element-784">
              <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-785" />
              All Products
            </Link>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4" data-id="element-786">
              {categoryInfo.title}
            </h1>
            <p className="text-white text-lg max-w-2xl" data-id="element-787">
              {categoryInfo.description}
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-788">
        {/* Filters and sort */}
        <div className="bg-white rounded-lg shadow-md p-4 mb-8" data-id="element-789">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-790">
            <div className="relative flex-grow max-w-md" data-id="element-791">
              <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" data-id="element-792" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-793" />
            </div>
            <div className="flex items-center space-x-4" data-id="element-794">
              <div className="relative" data-id="element-795">
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none bg-white" data-id="element-796">
                  <option value="featured" data-id="element-797">Featured</option>
                  <option value="price-low" data-id="element-798">Price: Low to High</option>
                  <option value="price-high" data-id="element-799">Price: High to Low</option>
                  <option value="rating" data-id="element-800">Highest Rated</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-801">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-802">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-803"></path>
                  </svg>
                </div>
              </div>
              <button className="flex items-center text-gray-600 border border-gray-300 rounded-lg px-4 py-2" data-id="element-804">
                <FilterIcon className="h-5 w-5 mr-2" data-id="element-805" />
                Filter
              </button>
            </div>
          </div>
          {/* Price range filter */}
          <div className="mt-4" data-id="element-806">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-807">
              Price Range: KSh {priceRange[0]} - KSh {priceRange[1]}
            </label>
            <div className="flex items-center gap-4" data-id="element-808">
              <input type="range" min="0" max="5000" step="100" value={priceRange[0]} onChange={e => setPriceRange([parseInt(e.target.value), priceRange[1]])} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-809" />
              <input type="range" min="0" max="5000" step="100" value={priceRange[1]} onChange={e => setPriceRange([priceRange[0], parseInt(e.target.value)])} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-810" />
            </div>
          </div>
        </div>
        {/* Product count */}
        <div className="mb-6" data-id="element-811">
          <p className="text-gray-600" data-id="element-812">
            Showing {sortedProducts.length} products
          </p>
        </div>
        {/* Product grid */}
        {sortedProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-813">
            {sortedProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-814" />)}
          </div> : <div className="text-center py-12" data-id="element-815">
            <p className="text-gray-600 text-lg mb-4" data-id="element-816">
              No products match your filters.
            </p>
            <button onClick={() => {
          setSearchQuery('');
          setPriceRange([0, 5000]);
        }} className="text-[#2e7d32] font-medium hover:underline" data-id="element-817">
              Clear all filters
            </button>
          </div>}
      </div>
    </div>;
};
export default CategoryPage;